import React, { useEffect, useState, useRef } from "react"
import "./styles.scss"
import { Button } from "../../components/Button"
import { useNavigate } from "react-router-dom"
import { useDispatch } from "react-redux"
import Send from "../../core/communication"
import { checkBackendConnectivity } from "../../core/utils/connectivity"
import { setData } from "../../core/redux/app/Actions"
import offlineIcon from "../../assets/icons/offline_downloading.svg"
import { FarmerImportContainer } from "../../container/FarmerImportContainer"

const PreFormOfflineScreen = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const farmerImportRef = useRef(null)

  useEffect(() => {
    Send.setOnline(false)
    dispatch(
      setData({
        online: false,
      }),
    )
  }, [])

  const handleNavigate = () => {
    dispatch(
      setData({
        online: true,
      }),
    )
    Send.setOnline(true)
    navigate("/")
  }

  return (
    <div className="pre-screen-form-off">
      <div className="pre-screen-form-off__image">
        <img src={offlineIcon} alt="Offline mode" />
      </div>
      <div className="pre-screen-form-off__description">
        <span className="pre-screen-form-off__description-top">
          Você está usando a versão offline!
        </span>
        <span className="pre-screen-form-off__description-bottom">
          Mesmo sem conexão, você pode continuar preenchendo os formulários de atendimento. Suas
          informações estão sendo salvas com segurança e serão sincronizadas automaticamente assim
          que a internet for restabelecida.
        </span>
      </div>

      <div className="pre-screen-form-off__button">
        <Button
          label="Formulários disponíveis"
          classButton="pre-screen-form-off__button-available-form"
          handleClick={() => navigate('/mobileform')}
        />
        <Button
          label="Cadastrar beneficiário"
          variant="outline"
          classButton="pre-screen-form-off__button-available-form pre-screen-form-off__button-register-user"
          handleClick={() => farmerImportRef.current?.handleOpenModal()}
        />
        <div className="pre-screen-form-off__farmer-import-container">
          <FarmerImportContainer 
            mobileForm={true} 
            ref={farmerImportRef}
          />
        </div>
        <Button
          variant="outlined"
          label="Retornar para online"
          classButton="pre-screen-form-off__button-available-form"
          handleClick={() => handleNavigate()}
        />
      </div>
    </div>
  )
}

export default PreFormOfflineScreen
